import Icon from '../components/Icon.vue'

Icon.register({
  'football-ball': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M481.5 60.3c6.3 23.9 13.7 61 14.5 104.5l-156.6-156.8c43.6 0.9 80.9 8.5 104.8 14.9 18.2 4.9 32.5 19.2 37.3 37.4zM14.5 451.7c-6.3-23.9-13.7-61-14.5-104.5l156.6 156.8c-43.6-0.9-80.9-8.5-104.8-14.9-18.2-4.9-32.5-19.2-37.3-37.4zM4.2 283.4c22.6-152.7 138.9-252 271.4-271.4l216.3 216.6c-22.7 152.7-139 252-271.5 271.4zM321.5 159.8l-28.3 28.5-28.3-28.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-22.6 22.6-28.3-28.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.3-22.6 22.6-28.3-28.3c-3.1-3.1-8.2-3.1-11.3 0l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l28.3 28.2-28.3 28.3c-3.1 3.1-3.1 8.2 0 11.3l11.3 11.3c3.1 3.1 8.2 3.1 11.3 0l28.3-28.3 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3 22.6-22.6 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3 22.6-22.7 28.3 28.3c3.1 3.1 8.2 3.1 11.3 0l11.3-11.3c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3 28.3-28.3c3.1-3.1 3.1-8.2 0-11.3l-11.3-11.3c-3.1-3.1-8.2-3.1-11.3 0z'
      }
    ]
  }
})
